import { HStack, Text, VStack } from "@chakra-ui/react";
import { Input, Image } from "../reusables";
import { HiMusicalNote } from "react-icons/hi2";

/**
 *
 * @param {Object} props
 * @param {string} props.objectID
 * @param {string} props.userame
 * @param {string} props.fullName
 * @param {string} props.coverPhotoFilename
 * @param {'normal' | 'xs'} props.size
 * @param {import("@chakra-ui/react").StackProps} props.containerProps
 * @returns
 */
const SearchUserItem = ({
  objectID,
  username,
  fullName,
  coverPhotoFilename,
  containerProps,
  size,
}) => {
  return (
    <HStack
      w="full"
      h="max-content"
      spacing={"3"}
      _hover={{
        background: "#313134",
      }}
      px="2"
      py="1.5"
      cursor={"pointer"}
      {...containerProps}
    >
      <Image
        firebaseStoragePath={`photos/${objectID}/cover/${coverPhotoFilename}`}
        h={size === "xs" ? "20px" : "40px"}
        w={size === "xs" ? "20px" : "40px"}
        borderRadius={"full"}
      />
      <VStack align={"flex-start"} spacing={"0"}>
        <Text
          fontSize={"12px"}
          fontWeight={"semibold"}
          color="white"
          noOfLines={1}
        >
          {fullName}{" "}
          {size === "xs" && <span style={{ color: "gray" }}>@{username}</span>}
        </Text>
        {size !== "xs" && (
          <Text fontSize={"xs"} color="gray.400">
            @{username}
          </Text>
        )}
      </VStack>
    </HStack>
  );
};

export default SearchUserItem;
